import {action, makeObservable, observable} from 'mobx';

import {
  IMCChannelShownFields,
  IMCCreateChannelResponse,
  IWebWidgetConfig,
  MCCreateChannel,
  MCCreateChannelResponse,
  WebWidgetCreate,
  entities,
} from '../../../../api/proto';
import Channel from '../../Channel';
import ChannelsStore from '../../ChannelsStore';

export class WebWidget {
  constructor(public channels: ChannelsStore) {
    makeObservable(this);
  }

  @observable loading = false;
  @observable processingRequest: MCCreateChannel | null = null;

  @action protected setLoading = (loading: boolean) => {
    this.loading = loading;
  };

  @action protected setProcessingRequest_ = (processingRequest: MCCreateChannel | null) => {
    this.loading = !!processingRequest;
    this.processingRequest = processingRequest;
  };

  createWidget = async (data: {config: IWebWidgetConfig; shownFields?: IMCChannelShownFields | null}) => {
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    const createChannel = new MCCreateChannel({
      type: entities.OzekonChannelType.OIT_WEB_WIDGET,
      shownFields: data.shownFields,
      webWidgetFlow: new WebWidgetCreate({
        config: data.config,
      }),
    });

    this.setProcessingRequest_(createChannel);
    const {error, res} = await this.channels.channelsRequest<IMCCreateChannelResponse>(
      {
        createChannel,
      },
      'createChannel',
    );
    this.setProcessingRequest_(null);

    if (error) {
      return {error, res};
    }

    let channel: Channel | null = null;
    if (res) {
      channel = new Channel(
        {
          channelID: res?.channelID,
          shownFields: data.shownFields,
          type: entities.OzekonChannelType.OIT_WEB_WIDGET,
          workspaceID: this.channels.workspace.id,
          state: {
            webWidget: {
              config: {
                ...data.config,
                APICode: res.webWidgetFlow?.APICode,
              },
            },
          },
        },
        this.channels.workspace,
      );
      this.channels.workspace.app.anal.channelSetupEvent(channel);

      this.channels.workspace.refreshMembers();
      this.channels.workspace.app.anal.channelSetupEvent(channel);
    }

    this.processCreateChannel_(res);

    return {error, res, channel};
  };

  private processCreateChannel_ = async (createChannel?: IMCCreateChannelResponse | null) => {
    if (createChannel?.result !== MCCreateChannelResponse.Result.R_INTERNAL_SERVER_ERROR) {
      await this.channels.load();
    }
  };
}

export default WebWidget;
